@if ({ stayCounter: staysKpiHelperService.stayCounter$ | async }; as data) {
  <div
    class="kpi-counter-section"
    [class.clickable]="data.stayCounter && data.stayCounter > 0"
    (click)="
      data.stayCounter && data.stayCounter > 0 && (isDrawerVisible = true)
    "
  >
    <p class="kpi-header-text p-0 m-0 stay-title text-truncate">
      {{ 'page.shift_timeline.kpi.stays' | translate }}
    </p>
    <div class="d-flex align-items-center p-0 m-0">
      <div class="kpi-counter-text p-0 m-0 me-3">
        @if (staysKpiHelperService.isLoadingCounter$ | async) {
          <nz-skeleton-element
            class="loader"
            nzType="avatar"
            [nzActive]="true"
            [nzSize]="'small'"
            [nzShape]="'square'"
          ></nz-skeleton-element>
        } @else {
          <div [style.color]="staysKpiHelperService.counterColor$ | async">
            {{ data.stayCounter }}
          </div>
        }
      </div>
      <div class="kpi-counter-text">
        <fa-icon class="stay-icon" [icon]="faBed"></fa-icon>
      </div>
    </div>
  </div>
}

<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzMask]="true"
  nzPlacement="right"
  [nzTitle]="'page.shift_timeline.kpi.stays' | translate"
  [nzClosable]="false"
  (nzOnClose)="isDrawerVisible = false"
>
  <ng-container *nzDrawerContent>
    @if (isDrawerVisible) {
      <wilson-stays-kpi-drawer-list
        (closeDrawer)="isDrawerVisible = false"
      ></wilson-stays-kpi-drawer-list>
    }
  </ng-container>
</nz-drawer>
